<div class="business-change-root">
  <div class="img-area">
    <app-rounded-image small
                       [src]="currentBusiness.imgSource">
    </app-rounded-image>
    <app-paragraph>
      {{ currentBusiness.businessName }}
      <span *ngIf="maxNameLength.currentBusiness" class="hovertext">{{ currentBusiness.businessName }}</span>
    </app-paragraph>
  </div>
  <mat-icon>arrow_forward</mat-icon>
  <div class="img-area">
    <app-rounded-image small
                       [src]="newBusiness.imgSource">
    </app-rounded-image>
    <app-paragraph>
      {{ newBusiness.businessName }}
      <span *ngIf="maxNameLength.newBusiness" class="hovertext">{{ newBusiness.businessName }}</span>
    </app-paragraph>
  </div>
</div>
